import { useSyncExternalStore } from 'react';
import { hsCodeStore } from '../context/store';

export function useSelectedCodes() {
  return useSyncExternalStore(hsCodeStore.subscribe, () => hsCodeStore.getHSCodes());
}
